import React, {useState} from "react"
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {EditForumName} from "../../../services/forum.service";
import {notification} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import TextInput from "../../../components/common/input-field/TextInput";


export default function ChangeForumName({close, ForumName, listing, setListing}) {
    const [loaders , setLoaders] = useState(false)
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoaders(true);
        let payload = {
            memberAssignedName: data.forum_name
        };

        try {
            let res = await EditForumName(payload);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });

                setListing((prev) => !prev); // Ensure re-render
                close(false); // Close modal
            }
        } catch (error) {
            console.error("Error updating forum name:", error);
            notification.error({
                message: "Error",
                description: "Failed to update the forum name. Please try again.",
                placement: "topRight",
                duration: 2,
            });
        } finally {
            setLoaders(false);
            setListing((prev) => !prev); // Ensure re-render
            close(false); // Close modal
        }
    }

    return(
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={"dfields"}>
                    <Controller
                        name="forum_name"
                          defaultValue={ForumName ? ForumName : ''}
                        control={control}
                        rules={{
                            required: Required,
                            maxLength: maxLength(100),
                            validate: checkEmptySpaces,
                        }}
                        render={({ field: { name, ...field } }) => (
                            <TextInput
                                placeholder={"Enter Forum Name"}
                                label={"Forum Name"}
                                defaultValue={ForumName ? ForumName : ''}
                                type={"text"}
                                field={field}
                                errors={errors.forum_name}
                                className={"required"}
                            />
                        )}
                    />
                </div>
                <div className={"dfields"} style={{ marginTop: 38 }}>
                    <ThemeButton
                        text={"Submit"}
                        className={"btn-light-lg"}
                        type={"submit"}
                        loader={loaders}
                    />
                </div>
            </Form>
        </div>
    )
}